import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Bell, BellRing } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { CATEGORIES } from '../lib/categories';
import { PushToggle } from './PushToggle';

export const useFollowedCategories = () => {
  const { user } = useAuth();
  const [cats, setCats] = useState([]);
  useEffect(() => {
    if (!user) { setCats([]); return; }
    api.get('/me/categories').then(({ data }) => setCats(data.categories)).catch(() => {});
  }, [user]);
  const toggle = async (id) => {
    if (!user) { toast.error('Connectez-vous pour activer les alertes'); return; }
    const next = cats.includes(id) ? cats.filter((c) => c !== id) : [...cats, id];
    try {
      const { data } = await api.put('/me/categories', { categories: next });
      setCats(data.categories);
      toast.success(data.categories.includes(id) ? 'Alerte activée : vous serez prévenue dès qu\'un live démarre' : 'Alerte désactivée');
    } catch { toast.error('Erreur'); }
  };
  return { cats, toggle, user };
};

export const FollowCategoryButton = ({ category, cats, toggle }) => {
  if (!category) return null;
  const on = cats.includes(category);
  return (
    <button data-testid={`follow-${category}`} onClick={() => toggle(category)}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${on
        ? 'bg-amber-500/15 border-amber-500/50 text-amber-300' : 'border-slate-700 text-slate-300 hover:border-amber-500/60 hover:text-white'}`}>
      {on ? <BellRing className="h-3.5 w-3.5" /> : <Bell className="h-3.5 w-3.5" />}
      {on ? 'Alerte activée' : 'M\'alerter des lives'}
    </button>
  );
};

export const CategoryAlerts = () => {
  const { cats, toggle } = useFollowedCategories();
  return (
    <section className="card-elev rounded-2xl p-5" data-testid="category-alerts">
      <h2 className="font-display text-xl font-bold flex items-center gap-2"><BellRing className="h-5 w-5 text-amber-400" />Mes alertes lives</h2>
      <p className="text-sm text-slate-400 mt-1">Soyez prévenue (notification + e-mail) dès qu'un live démarre dans vos catégories.</p>
      <div className="mt-3"><PushToggle /></div>
      <div className="flex flex-wrap gap-2 mt-4">
        {CATEGORIES.filter((c) => c.id !== 'autre').map((c) => (
          <button key={c.id} data-testid={`alert-${c.id}`} onClick={() => toggle(c.id)}
            className={`px-3 py-1.5 rounded-full text-sm font-semibold border transition-colors ${cats.includes(c.id)
              ? 'bg-amber-500 border-amber-500 text-slate-900' : 'border-slate-700 text-slate-300 hover:border-amber-500/60'}`}>
            {c.label}
          </button>
        ))}
      </div>
    </section>
  );
};
